import { render, staticRenderFns } from "./teamMemberItem.vue?vue&type=template&id=64f5f1f1&scoped=true"
import script from "./teamMemberItem.vue?vue&type=script&lang=js"
export * from "./teamMemberItem.vue?vue&type=script&lang=js"
import style0 from "./teamMemberItem.vue?vue&type=style&index=0&id=64f5f1f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5f1f1",
  null
  
)

export default component.exports